
import React, { Component}  from 'react';

import { FormProvider, FormContext } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { ChoiceForm } from './Form';


export default class ChoiceAdd extends Component {

  componentDidMount() {
    document.title = 'Новое значение';
  }

  onDetail = (item) => {
    this.props.history.push(`/catalog/choice`);
  };

  render() {
    const { location } = this.props;
    return (
      <FormProvider
        url={'catalog/choice'}
        postSave={(item) => this.onDetail(item)}
        postSaveMessage={'Значение добавлено'}
        location={location}
        item={{
          is_active: true
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <Layout>
              <Layout.Header
                title={'Новое значение'}
                backUrl={'/catalog/choice'}
              />

              <Layout.ContentSimple>
                <ChoiceForm />

                <div className={'mt-30'}>
                  <YellowButton
                    onClick={(e) => context.handleSubmit(e)}
                    size={'large'}
                    disabled={loading}
                  >
                    Создать
                  </YellowButton>

                </div>
              </Layout.ContentSimple>
            </Layout>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
